/*eslint-disable*/
import React, { useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
//import FormControlLabel from "@material-ui/core/FormControlLabel";
// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Slider from "nouislider";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import SweetAlert from "react-bootstrap-sweetalert";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Datetime from "react-datetime";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "../../utils/axiosInstance";
import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";
// style for this view
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import reactDom from "react-dom";
import RichTextEditor from "react-rte";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import ImageUploading from "react-images-uploading";
import { CircularProgress } from "@material-ui/core";

//const baseURL = "https://jsonplaceholder.typicode.com/api/v1/admin/login";
const useStyleData = makeStyles(stylesData);

const useStyles = makeStyles(styles);

export default function BannerHomePage() {
  let fileInput = React.createRef();

  const [formValues, setFormValues] = React.useState({
    title: "",
    description: "",
  });
  const [file, setFile] = React.useState(null);
  const [avatar, setAvatar] = React.useState(true);
  const [selectedFile, setSelectedFile] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [alert, setAlert] = React.useState(null);
  const [imageName, setImageName] = React.useState("");
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
    avatar ? defaultAvatar : defaultImage
  );
  const [editorBody, setEditorBody] = React.useState(RichTextEditor.createEmptyValue());
  const [preview, setPreview] = useState([]);

  const [images, setImages] = useState([]);
  const maxNumber = 69;
  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
    console.log(imageList, "hhjv")
  };

  const handleEditorChange = (newValue) => {
    setEditorBody(newValue);
    setFormValues({
      ...formValues,
      "description": newValue.toString("html"),
    });

  };
  // const handleImageChange = (e) => {
  //   e.preventDefault();
  //   setImageName("");
  //   let reader = new FileReader();
  //   let file = e.target.files[0];
  //   setSelectedFile(e.target.files[0]);
  //   //setImageName()
  //   reader.onloadend = () => {
  //     setAvatar(true);
  //     setFile(file);
  //     setImagePreviewUrl(reader.result);
  //   };
  //   if (file) {
  //     reader.readAsDataURL(file);
  //   }
  //   console.log(file, imagePreviewUrl)
  // };

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.id]: e.target.value,
    });
    console.log(formValues);
  };

  const hideAlert = () => {
    setAlert(null);
    // window.location.assign("/admin/dashboard");
  };

  React.useEffect(() => {
    setImageName("");
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      setLoading(true);
      try {
        await axios
          .get(
            `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/homePageBanner`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Access-Control-Allow-Origin": "*",
              },
            }
          )
          .then((res) => {
            const data = res.data.data;
            setFormValues({
              title: data[0].title,
              description: data[0].description,
            });
            setImageName(data[0].bannerImage);
            // preview.push(event.target.result);   // update the array instead of replacing the entire value of preview

            // setPreview(data[0].bannerImage);
            let myImages = [];
            data[0].bannerImage.map(img => {
              myImages.push({ data_url: `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/uploads/${img}` });
            })
            setImages(myImages);
            setEditorBody(RichTextEditor.createValueFromString(data[0].description, 'html'));
            //setEditorBody(.toString('html')))
            setImagePreviewUrl(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/uploads/` + data[0].bannerImage)
          });
      } catch (error) {
        console.error(error.message);
        if (error?.response?.data?.message == "For security reasons, we locked your account.Please login to continue") {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  const handleRemove = () => {
    setFile(null);
    //setAvatar(false);
    // setImageurl(null);
    setImagePreviewUrl(defaultAvatar);
    fileInput.current.value = null;
  };


  const handleSubmitForm = async () => {
    const token = localStorage.getItem("token");
    const formData = new FormData();

    for (const key in formValues) {
      formData.append(key, formValues[key]);
    }
    // if (imageName === "undefined" || imageName === "")
    //   formData.append("bannerImage", selectedFile);
    // else {
    //   formData.append("bannerImage", imageName);
    // }
    // formData.append("bannerImage", selectedFile);
    images.map(s => {
      if (s.file) {
        formData.append("bannerImage", s.file)
      }
      else {
        formData.append("previousImages", s.data_url)
      }
      // console.log(s)
    })
    // console.log(images, "qwertyuiop[")
    axios.put(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/homePageBanner`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        }
      }

    ).then((res) => {
      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <span
              style={{
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {res?.data?.message}
            </span>
          }
          onConfirm={() => hideAlert()}
          onCancel={() => hideAlert()}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={
            classesSweetAlert.button + " " + classesSweetAlert.success
          }
        />
      );

    })
      .catch((err) => {
        setAlert(
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {err?.response?.data?.message}
              </span>
            }
            onConfirm={() => hideAlert()}
            onCancel={() => hideAlert()}
            titleCssClass={classesSweetAlert.cardTitle}
            confirmBtnCssClass={
              classesSweetAlert.button + " " + classesSweetAlert.success
            }
          />
        );

      })
  }
  const classes = useStyles();
  const classesSweetAlert = useStyleData();

  const fileobj = [];

  // const changedHandler = event => {
  //   console.log(preview,"useee")
  //     let files = event.target.files;
  //     fileobj.push(files);
  //     let reader;

  //     for (var i = 0; i < fileobj[0].length; i++) {
  //         reader = new FileReader();
  //         reader.readAsDataURL(fileobj[0][i]);
  //         reader.onload = event => {
  //         preview.push(event.target.result);   // update the array instead of replacing the entire value of preview
  //         // setSelectedFile([...new Set(preview)]);
  //         setPreview([...new Set(preview)]); // spread into a new array to trigger rerender
  //         // console.log(preview,"handle")
  //         } 
  //     } 
  //     // setSelectedFile([])
  //     setSelectedFile(event.target.files)
  //     console.log(event.target.files.length,"testt")
  // }
  return (
    <div>

      {!loading ? (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <MailOutline />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Banner HomePage</h4>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={4} md={12}>
                      <legend>Banner Images</legend>
                      {/* <ImageUpload
                      avatar
                      fileValue={file}
                      handleRemove={handleRemove}
                      imagePreviewUrlValue={imagePreviewUrl}
                      handleImageChange={handleImageChange}
                      addButtonProps={{
                        color: "rose",
                        round: true,
                      }}
                      changeButtonProps={{
                        color: "rose",
                        round: true,
                      }}
                      removeButtonProps={{
                        color: "danger",
                        round: true,
                      }}
                      /> */}
                      {/* <div>
                        <input
                          type="file"
                          name="file"
                          multiple
                          onChange={changedHandler} />

                        <div className="form-group multi-preview">
                        {console.log(preview,"useee")}
                          {(preview || []).map((url, index) => (
                            <img src={url} alt="..." key={index} style={{ height: '200px', width: '200px' , margin:"10px" }} />
                          ))}
                        </div>

                      </div> */}
                      <ImageUploading
                        multiple
                        value={images}
                        onChange={onChange}
                        maxNumber={maxNumber}
                        dataURLKey="data_url"
                      // acceptType={["jpg"]}
                      >
                        {({
                          imageList,
                          onImageUpload,
                          onImageRemoveAll,
                          onImageUpdate,
                          onImageRemove,
                          isDragging,
                          dragProps
                        }) => (
                          // write your building UI
                          <div className="upload__image-wrapper">
                            <Button
                              color="rose"
                              // className={classes.registerButton}
                              onClick={onImageUpload}
                              {...dragProps}
                            >
                              Click or Drop here
                            </Button>
                            &nbsp;
                            <Button
                              color="rose"
                              // className={classes.registerButton}
                              onClick={onImageRemoveAll}
                              {...dragProps}
                            >
                              Remove all images
                            </Button>
                            {imageList.map((image, index) => (
                              <GridContainer>
                                {/* <div key={index} className="image-item"> */}
                                <GridItem sx={{ display: "flex" }}>
                                  <img src={image.data_url} alt="" width="100" />
                                  <div className="image-item__btn-wrapper" style={{ width: "300px" }}>
                                    <Button
                                      color="rose"
                                      // className={classes.registerButton}
                                      onClick={() => onImageUpdate(index)}
                                    >
                                      Update
                                    </Button>
                                    <Button
                                      color="rose"
                                      // className={classes.registerButton}
                                      onClick={() => onImageRemove(index)}
                                    >
                                      Remove
                                    </Button>
                                  </div>
                                </GridItem>
                              </GridContainer>
                              // </div>

                            ))}
                          </div>
                        )}
                      </ImageUploading>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        labelText="Heading"
                        id="title"
                        handleChange={handleChange}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          value: formValues?.title
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12}>
                      <RichTextEditor
                        value={editorBody}
                        onChange={handleEditorChange}
                        style={{ height: "300px" }}
                      />
                    </GridItem>
                  </GridContainer>

                  <Button
                    color="rose"
                    className={classes.registerButton}
                    onClick={handleSubmitForm}
                  >
                    Save
                  </Button>
                </form>
              </CardBody>
            </Card>
          </GridItem>
          {alert}
        </GridContainer>

      ) : (<div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>)}
    </div>
  );
}
